// When the canvas legends may write a record by drag-and-drop.
//
// A drop writes a clinical record and arms the pedigree save exactly as the
// sidebar's Diseases / Phenotypes / Genotypes sections do, so it is refused
// wherever those sections are (PedigreeSideBar's sectionsAreDisabled). A
// secondary (linked) record is refused by the server's secondaryRecordGuard,
// whose message the drop shows.
//
// Deliberately NOT gated on `lockResolved`: it stays false when the lock read
// FAILS, which would switch dragging off for good. The sidebar sections do not
// wait on it either, and the save they arm is refused by planSaveAttempt if the
// lock turns out to be someone else's.

/** Whole-chart cases: dragging is simply off. */
export const legendDragAllowed = ({ isLocked, preview, patient }) =>
  !isLocked && !preview && !patient;

/**
 * Per-person cases, asked at drop time (and again when the disease age dialog is
 * saved). `getChartBox` returns ChartBox's imperative handle.
 *
 * A proxy symbol has its own canvas pid, while the lock is held on the person it
 * redraws, so both pids are asked.
 *
 * @returns {({ member, canvasPid }) => string|null} a refusal, or null
 */
export const makeLegendDropBlocker =
  (getChartBox) =>
  ({ member, canvasPid } = {}) => {
    const chartBox = getChartBox?.();
    if (chartBox?.isBulkEditActive?.()) {
      return 'Finish the bulk edit before adding records from the legend.';
    }
    if (
      chartBox?.isPersonLockedByOther?.(canvasPid) ||
      chartBox?.isPersonLockedByOther?.(member?.pid)
    ) {
      return 'This person is being edited by another user.';
    }
    return null;
  };
